/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Buttons.module.css';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
// button with image
class ImgBtn extends Component {
  static defaultProps = {
    title: '',
    disabled: false,
    small: false,
  };

  render() {
    let size = '4rem';
    if (this.props.small) {
      size = '2rem';
    }
    const btnImgStyle = {
      width: size,
      height: size,
    };
    return (
      <button
        type="button"
        className={styles.img}
        onClick={this.props.onClick}
        title={this.props.title}
        disabled={this.props.disabled}

        // dataToolTip={this.props.dataToolTip}
      >
        <img src={this.props.src} alt="" aria-hidden="true" style={btnImgStyle} />
      </button>
    );
  }
}

export default ImgBtn;
